<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div class="ly_pop_content ly_pop_msg ly_txt card relative">
        <div class="ly_pop_head">
          <a class="btn_ly_close svg_close" @click="close">
            <span>{{ $t('library.deletemodal.close') }}</span>
          </a>
        </div>
        <div class="ly_inner ly_txt">
          <p class="tac" style="font-size: 20px; font-weight: bold;">
            교·강사 회원으로 전환하시겠습니까?<br />
          </p>
          <div class="warningText">
            교·강사 회원 전환 시 일반 회원으로 전환 불가
          </div>

          <div class="btn_wrap">
            <button type="submit" class="box_btn dull" @click="close">
              <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
            </button>
            <button type="submit" class="box_btn" @click="goNext()">
              <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>
<script>
export default {
  name: 'ChangeModal',
  props: {
    bookshelf: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async goNext() {
      this.$emit('goNext')
      // this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.box_btn {
  margin-left: 6px !important;
  margin-right: 6px !important;
}

.warningText {
  color: red;
  margin-top: 15px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}
</style>
